<script>
import { api } from "@/state/services";
import { voucherStatus, formatDate } from "@/state/helpers/experiences";

// Resgates em andamento: contagem de pendentes/aprovados e os 3 mais recentes
export default {
  data() {
    return {
      loading: true,
      errored: false,
      list: [],
    };
  },
  computed: {
    pending() {
      return this.list.filter((item) => item.status == "pending").length;
    },
    approved() {
      return this.list.filter((item) => item.status == "approved").length;
    },
    recent() {
      return this.list
        .filter((item) => item.status == "pending" || item.status == "approved")
        .sort((first, second) => String(second.date).localeCompare(String(first.date)))
        .slice(0, 3);
    },
  },
  methods: {
    voucherStatus,
    formatDate,
  },
  mounted() {
    api
      .get("experiences/vouchers")
      .then((response) => {
        if (response.data && response.data.status == "success") {
          this.list = response.data.list || [];
        } else {
          this.errored = true;
        }
      })
      .catch(() => {
        this.errored = true;
      })
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>

<template>
  <div class="card">
    <div class="card-body p-3">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h5 class="font-size-15 mb-0">Meus resgates em andamento</h5>
        <router-link to="/experiences/vouchers" class="font-size-13">Ver todos</router-link>
      </div>
      <div v-if="loading">
        <b-skeleton v-for="n in 3" :key="n" class="mb-2"></b-skeleton>
      </div>
      <p v-else-if="errored" class="text-muted mb-0">Não foi possível carregar seus resgates agora.</p>
      <template v-else>
        <div class="d-flex mb-2">
          <span class="badge badge-warning mr-2">{{ pending }} aguardando</span>
          <span class="badge badge-success">{{ approved }} {{ approved == 1 ? "aprovado" : "aprovados" }}</span>
        </div>
        <p v-if="recent.length == 0" class="text-muted mb-0">Nenhum resgate em andamento.</p>
        <ul v-else class="list-unstyled mb-0">
          <li v-for="item in recent" :key="item.protocol" class="border-bottom">
            <router-link :to="'/experiences/vouchers/' + item.protocol" class="d-flex justify-content-between align-items-center py-2 text-body">
              <div class="text-truncate mr-2">
                <div class="text-truncate">{{ item.experience.title }}</div>
                <small class="text-muted notranslate">{{ item.protocol }} · {{ formatDate(item.date) }}</small>
              </div>
              <span :class="'badge badge-' + voucherStatus(item.status).variant">{{ voucherStatus(item.status).label }}</span>
            </router-link>
          </li>
        </ul>
      </template>
    </div>
  </div>
</template>
